<template>
  <v-progress-circular
    v-if="isLoading"
    :size="70"
    :width="7"
    color="primary"
    indeterminate
    class="centered"
  ></v-progress-circular>
  <div v-else>
    <div class="row">
      <div class="col-4">
        <BrandDropdown
          v-model="brandSelected"
          @setBrand="setBrand"
        ></BrandDropdown>
      </div>
      <div class="col text-right align-self-end">
        <button
          @click="() => $router.push({ name: 'DetailNews' })"
          class="btn btn-outline-primary"
        >
          Create
        </button>
      </div>
    </div>
    <div class="mt-3">
      <div class="row">
        <div class="d-flex align-items-center justify-content-start col">
          <span style="margin-right: 1rem">Show</span>
          <b-form-select
            class="form-control"
            style="width: 20%"
            v-model="perPage"
            :options="pageOptions"
            @change="onChangeEntries"
          ></b-form-select>
          <span style="margin-left: 1rem">entries</span>
        </div>
        <div class="d-flex align-items-center justify-content-end col">
          <label for="searchText" class="mx-3">Search: </label>
          <input
            id="searchText"
            type="text"
            v-model="searchText"
            class="form-control w-50"
            @change="getList"
          />
        </div>
      </div>

      <b-table
        class="table table-responsive table-bordered mt-5"
        hover
        :fields="fields"
        :items="listNews"
        :per-page="perPage"
        @sort-changed="sortCompare"
        responsive
      >
        <template #cell(action)="data">
          <div class="d-flex justify-content-evenly">
            <button
              @click="
                () =>
                  $router.push({
                    name: 'DetailNews',
                    query: { id: data.item.id },
                  })
              "
              class="btn btn-outline-primary"
            >
              Detail
            </button>
          </div>
        </template>
      </b-table>
      <b-pagination
        :total-rows="totalItems"
        v-model="currentPage"
        :per-page="perPage"
        class="my-0"
        aria-controls="my-table"
        @input="changePage"
      ></b-pagination>
    </div>
  </div>
</template>

<script>
import NewsService from "@/services/api/news.service";
import BrandDropdown from "components/Brand/BrandDropdown";
import DefaultListViewData from "@/views/defaultListViewData";
export default {
  components: {
    BrandDropdown,
  },
  data() {
    return {
      ...DefaultListViewData,
      deleteId: null,
      listNews: [],
      fields: [
        {
          key: "id",
          label: "ID",
          sortable: true,
        },
        {
          key: "title",
          label: "Title",
          thClass: "text-start",
          tdClass: "text-start",
          sortable: true,
        },
        {
          key: "brandName",
          label: "Brand",
          thClass: "text-start",
          tdClass: "text-start",
          sortable: true,
        },
        {
          key: "categoryName",
          label: "Category",
          thClass: "text-start",
          tdClass: "text-start",
          class: "table-width",
          sortable: true,
        },
        {
          key: "publishedStatus",
          label: "Status",
          thClass: "text-start",
          tdClass: "text-start",
          class: "table-width",
        },
        {
          key: "startPublishedDate",
          label: "Start Publish Date",
          thClass: "text-start",
          tdClass: "text-start",
          class: "table-width",
          sortable: true,
        },
        {
          key: "endPublishedDate",
          label: "End Publish Date",
          thClass: "text-start",
          tdClass: "text-start",
          class: "table-width",
          sortable: true,
        },
        {
          key: "action",
          label: "Action",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
    };
  },
  mounted() {
    this.isLoading = true;
    this.getList(this.sort);
  },
  methods: {
    async getList(sort) {
      try {
        const param = {
          currentPage: this.currentPage,
          limit: this.perPage,
          brand: this.brandSelected?.id,
          sortColumn: sort.key || "id",
          sortType: sort.type || "desc",
          key: this.searchText,
        };
        await NewsService.getListNews(param)
          .then((res) => {
            const data = res.data;
            this.totalItems = data.totalItems;
            this.listNews = data.news;
            this.listNews = data.news.map((i) => {
              return {
                ...i,
                categoryName: NewsService.formatNewsCategory(i.categoryName),
              };
            });
            this.isLoading = false;
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    async deleteItem() {
      this.isLoading = true;
      try {
        await NewsService.deleteNews(this.deleteId)
          .then((res) => {
            const data = res.data;
            if (data.status !== "success") {
              console.log("Error: ", data.message);
            }
            this.getList();
            this.isLoading = false;
            this.hideDialog();
          })
          .catch((err) => {
            console.log("Error: ", err);
            this.isLoading = false;
          });
      } catch (error) {
        console.log("Error: ", error);
        this.isLoading = false;
      }
    },
    setBrand(brand) {
      this.brandSelected = brand || "";
      this.getList(this.sort);
    },
    changePage() {
      this.getList(this.sort);
    },
    onChangeEntries() {
      this.getList(this.sort);
    },
    sortCompare(e) {
      let sortBy = e.sortBy;
      if (sortBy === "title") {
        sortBy = "titleEn";
      } else if (sortBy === "brandName") {
        sortBy = "brand.brandName";
      } else if (sortBy === "categoryName") {
        sortBy = "category";
      }
      this.sort = {
        key: sortBy,
        type: e.sortDesc ? "desc" : "asc",
      };
      this.getList(this.sort);
    },
  },
};
</script>

<style lang="scss" scoped>
.table {
  margin: 1rem 0;
}
.centered {
  position: absolute;
  top: 45%;
  left: 50%;
}
.btn-del {
  margin-left: 5px;
  color: red;

  .btn-del:hover {
    color: white;
  }
}
.content-dialog {
  height: 300px;
  background: #fff;

  h3 {
    text-align: center;
    padding: 5rem 0 2rem;
  }

  .btn-back {
    border: 1px solid #1976d2;
    width: 28%;
    height: 39px;
    border-radius: 25px;
    color: #1976d2;
  }
  .btn-back:hover {
    text-decoration: underline;
  }
}
</style>
